import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React from 'react';
import { IndicatorContainer, splitContainerProps } from '../../internal';
import { withRef } from '../../utils';
let count = 0;
export const Checkbox = withRef(function Checkbox({ id = `castor_checkbox_${++count}`, bordered, invalid, children, className, style, ...restProps }, ref) {
    const { disabled, touched } = useField();
    const [containerProps, inputProps] = splitContainerProps(restProps);
    return (React.createElement(IndicatorContainer, { ...containerProps, htmlFor: id, bordered: bordered, className: className, style: style }, {
        children,
        input: (React.createElement("input", { disabled: disabled, ...inputProps, ref: ref, id: id, type: "checkbox", className: classy(c('checkbox'), m({ invalid, touched })) })),
    }));
});
//# sourceMappingURL=checkbox.js.map